import { FC } from 'react'
import { IoFootsteps } from 'react-icons/io5'

import CustomText from '../../CustomText'

type HeadingViewProps = {
  stepCount: number
  totalStep: number
  title: string
  description: string
}

export const HeadingView: FC<HeadingViewProps> = ({
  stepCount,
  totalStep,
  title,
  description
}: HeadingViewProps) => {
  return (
    <div className={`w-full h-auto flex flex-col gap-y-4`}>
      <div className="w-fit h-auto bg-white flex flex-row items-center rounded-full px-[8px] py-[4px] gap-x-[12px] border-solid border-[1.5px] border-[#cdcdcd]">
        <IoFootsteps className="w-[20px] h-[20px]" />
        <CustomText
          textLabel={`Step ${stepCount} of ${totalStep}`}
          fontWeight={`font-regular`}
          fontSize="text-[14px]"
          fontColor={`text-black`}
        />
      </div>
      <CustomText
        textLabel={title}
        fontWeight={`font-bold`}
        fontSize="text-[28px]"
        fontColor={`text-black`}
      />

      <div className="w-[80%]">
        <CustomText
          textLabel={description}
          fontWeight={`font-regular`}
          fontSize="text-[16px]"
          fontColor={`text-black`}
        />
      </div>
    </div>
  )
}

export default HeadingView
